(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rs-schwenk"] && !Shopify.designMode) return;
  try {
    function rsSchwenkRuhig(el) {
    if (el.getAttribute('data-rs-bewegung') === 'false') return true;
    if (document.documentElement.classList.contains('ohne-bewegung')) return true;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function rsSchwenkInit(el) {
    if (el.hasAttribute('data-rs-init')) return;
    el.setAttribute('data-rs-init', '');
    var bild = el.querySelector('.rs-schwenk__bild');
    var knopf = el.querySelector('[data-rs-schwenk-knopf]');
    if (!bild || !knopf) return;
    var text = knopf.querySelector('[data-rs-schwenk-text]');
    var symPause = knopf.querySelector('[data-symbol="pause"]');
    var symAbspielen = knopf.querySelector('[data-symbol="abspielen"]');
    var gestartet = false;
    var angehalten = false;

    function zeige() {
      if (text) text.textContent = el.getAttribute(angehalten ? 'data-text-fortsetzen' : 'data-text-anhalten');
      if (symPause) symPause.hidden = angehalten;
      if (symAbspielen) symAbspielen.hidden = !angehalten;
      bild.classList.toggle('pausiert', angehalten);
    }

    function ruhe() {
      var r = rsSchwenkRuhig(el);
      bild.classList.toggle('standbild', r);
      if (r) {
        bild.classList.remove('laeuft', 'pausiert', 'ausser-sicht');
        knopf.hidden = true;
      } else if (gestartet) {
        bild.classList.add('laeuft');
        knopf.hidden = false;
        zeige();
      }
    }

    function start() {
      if (rsSchwenkRuhig(el) || gestartet) return;
      gestartet = true;
      bild.classList.add('laeuft');
      knopf.hidden = false;
      zeige();
    }

    knopf.addEventListener('click', function () {
      angehalten = !angehalten;
      zeige();
    });

    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', ruhe);
      else if (mq.addListener) mq.addListener(ruhe);
    }
    ruhe();
    if (rsSchwenkRuhig(el)) return;

    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.6) start();
        // Außer Sicht ruht die Schleife von selbst; der Zustand des Knopfs bleibt davon unberührt
        bild.classList.toggle('ausser-sicht', !e.isIntersecting);
      });
    }, { threshold: [0, 0.6] });
    io.observe(bild);
  }

  function rsSchwenkAlle(wurzel) {
    var liste = (wurzel || document).querySelectorAll('[data-rs-schwenk]');
    for (var i = 0; i < liste.length; i++) rsSchwenkInit(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rsSchwenkAlle(document); });
  } else {
    rsSchwenkAlle(document);
  }
  document.addEventListener('shopify:section:load', function (e) { rsSchwenkAlle(e.target); });
  } catch(e) { console.error(e); }
})();

})();
